<template>
  <div>
    <table
      class="table table-striped table-sm"
      v-if="orders && orders.length > 0"
    >
      <thead>
        <tr style="width: 100%">
          <th scope="col">
            <input type="checkbox" class="mr-4" v-model="selectAll" />
            <img
              v-if="orders && orders.length > 0"
              class="printer-icon"
              @click="generatePdf"
              src="../../icons/dod/printer.svg"
              alt=""
            />
          </th>
          <th scope="col">Status rozliczenia</th>
          <th scope="col">Opiekun</th>
          <th scope="col">Numer telefonu</th>
          <th scope="col">Dni</th>
          <th scope="col">Ilość godz. zaplanowanych</th>
          <th scope="col">Ilość godz. wykonanych</th>

          <th scope="col"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in orders" :key="order.id">
          <td>
            <input
              type="checkbox"
              class="mr-4"
              v-model="selectedOrdersIds[order.id]"
            />
            <img
              class="printer-icon"
              @click="editOrder(order)"
              src="../../icons/dod/pen.svg"
              alt=""
            />
          </td>
          <td>
            <settlement-status-badge
              :status="settlementStatusFor(order.employee.id)"
            />
          </td>

          <td>
            {{ order.employee.firstName }} {{ order.employee.lastName }}
            <span
              v-if="order.employee.mainAppUserId && panelCan('showMainAppLinking')"
              class="seniorapp-label"
              >{{ $mainAppBadge }}</span
            >
          </td>
          <td>{{ order.employee.phone }}</td>
          <td>{{ getWeekdaysShortNames(order.days) }}</td>
          <td>
            {{
              order.days.reduce(
                (hours, day) => (hours = hours + day.numberOfHours),
                0
              )
            }}
          </td>
          <td>
            {{
              order.days.reduce(
                (hours, day) => (hours = hours + day.numberOfMadeHours),
                0
              )
            }}
          </td>

          <td>
            <gradient-button
              @handleClick="moveToEmployeeDetails(order.employee.id)"
              :title="'Przejdź'"
              :customStyles="'width: 5vw; font-size: calc(11px + 0.05vw);'"
            />
          </td>
          <td>
            <img
              class="printer-icon"
              @click="deleteOrder(order)"
              src="../../icons/dod/trash.svg"
              alt=""
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import shared from "../../shared";
import GradientButton from "./GradientButton.vue";
import SettlementStatusBadge from "./settlement/SettlementStatusBadge.vue";
export default {
  components: { GradientButton, SettlementStatusBadge },
  name: "DodCustomerOrders",
  props: ["customerId"],
  emits: ["editOrder", "deleteOrder"],
  data() {
    return {
      selectAll: false,
      selectedOrdersIds: {},
      settlementByEmployee: {},
    };
  },

  watch: {
    selectAll() {
      this.orders.forEach((order) => {
        this.selectedOrdersIds[order.id] = this.selectAll;
      });
    },
    orders: {
      immediate: true,
      handler() {
        this.fetchSettlementStatuses();
      },
    },
  },

  methods: {
    settlementStatusFor(employeeId) {
      const s = this.settlementByEmployee[employeeId];
      return s ? s.status : "NIEROZLICZONO";
    },
    async fetchSettlementStatuses() {
      const employeeIds = [...new Set(this.orders.map((o) => o.employee.id))];
      if (employeeIds.length === 0) {
        this.settlementByEmployee = {};
        return;
      }
      try {
        const statuses = await this.$store.dispatch(
          "getSettlementStatusesByEmployees",
          {
            employeeIds,
            month: this.customersFetchParams
              ? this.customersFetchParams.ordersMonth
              : null,
            year: this.customersFetchParams
              ? this.customersFetchParams.ordersYear
              : null,
          }
        );
        const map = {};
        (statuses || []).forEach((s) => {
          map[s.employeeId] = s;
        });
        this.settlementByEmployee = map;
      } catch (e) {
        this.settlementByEmployee = {};
      }
    },
    deleteOrder(order) {
      const question =
        order.employee?.mainAppUserId && this.panelCan("showMainAppLinking")
          ? `Czy na pewno chcesz usunąć zlecenie? Usunięcie zlecenia spowoduje informację dla Opiekunki i zmianę statusu na UNREALIZED`
          : `Czy na pewno chcesz usunąć zlecenie?`;
      if (confirm(question)) {
        this.$emit("deleteOrder", order);
      }
    },
    editOrder(order) {
      this.$emit("editOrder", order);
    },
    getWeekdaysShortNames(orderDays) {
      const daysWithoutDuplicates = [
        ...new Set(orderDays.map((d) => d.dayName)),
      ];
      const dirEn = {
        MONDAY: "PON",
        TUESDAY: "WT",
        WEDNESDAY: "ŚR",
        THURSDAY: "CZW",
        FRIDAY: "PT",
        SATURDAY: "SOB",
        SUNDAY: "ND",
      };

      let daysPl = [];
      Object.entries(dirEn).forEach(([key, value]) => {
        if (daysWithoutDuplicates.includes(key)) {
          daysPl.push(value);
        }
      });

      return daysPl.join(", ");
    },

    moveToEmployeeDetails(employeeId) {
      this.$router.push({
        name: "DodEmployeeDetails",
        params: { id: employeeId },
      });
    },

    async generatePdf() {
      for (const [key, value] of Object.entries(this.selectedOrdersIds)) {
        if (key && value) {
          await this.handlePrint(key);
        }
      }
    },

    async handlePrint(key) {
      const response = await this.$store.dispatch("generateWorkingCardPdf", {
        orderId: key,
        month: this.customersFetchParams.ordersMonth,
        year: this.customersFetchParams.ordersYear,
      });
      const fileURL = window.URL.createObjectURL(new Blob([response]));
      const fileLink = document.createElement("a");
      const monthName = shared.getPolishMonthNameByMonthNumber(
        this.customersFetchParams.ordersMonth - 1
      );
      const employee = this.orders.find((order) => order.id === key)?.employee;
      const customer = this.orders.find((order) => order.id === key)?.customer;
      const filename = `Karta pracy opiekuna ${employee.firstName} ${
        employee.lastName
      } i podopiecznego ${customer.firstName} ${
        customer.lastName
      } na miesiąc ${monthName.toLowerCase()}.pdf`;

      fileLink.href = fileURL;
      fileLink.setAttribute("download", filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
  },

  computed: {
    orders() {
      return this.$store.getters.getDodSelectedCustomerOrders?.data || [];
    },
    customersFetchParams() {
      return this.$store.getters.getDodCustomerFetchParams;
    },
  },
};
</script>

<style  scoped>
table {
  table-layout: fixed;
  font-size: calc(11px + 0.05vw) !important;
}
.printer-icon {
  cursor: pointer;
}
</style>